(function($){
    $('abbr.timeago').timeago();
}(jQuery));
